import { forwardRef } from "react";

import dynamic from "next/dynamic";
import { FieldValues } from "react-hook-form";

import { AutocompleteProps, AutocompleteSsrProps } from "./types";

// Disabled SSR to avoid memory leak caused by styled
const DynamicDashboardAutocomplete = dynamic(
  () => import("./DashboardAutocompleteSsr").then((mod) => mod.DashboardAutocompleteSsr),
  { ssr: false }
) as <
  Value,
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined,
  T extends FieldValues = FieldValues,
>(
  props: AutocompleteSsrProps<Value, Multiple, DisableClearable, FreeSolo, T>
) => React.ReactElement;

// Wrap dynamic component with forwardRef and pass ref as forwardedRef prop
// This is necessary because next/dynamic doesn't properly forward refs
const DashboardAutocompleteInner = forwardRef(function DashboardAutocompleteInner<
  Value,
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined,
  T extends FieldValues = FieldValues,
>(props: AutocompleteProps<Value, Multiple, DisableClearable, FreeSolo, T>, ref: React.Ref<HTMLInputElement>) {
  return <DynamicDashboardAutocomplete {...props} forwardedRef={ref} />;
});

export const DashboardAutocomplete = DashboardAutocompleteInner as <
  Value,
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined,
  T extends FieldValues = FieldValues,
>(
  props: AutocompleteProps<Value, Multiple, DisableClearable, FreeSolo, T> & React.RefAttributes<HTMLInputElement>
) => React.ReactElement;
